module.exports = __webpack_public_path__ + "img/A58A2490_min.254eede5.jpg";